module.exports = __webpack_public_path__ + "media/images/lb/971-14aba634a2b8747ddecfa1442b8e0106.svg";